import React, { useContext } from 'react';
import { MandatoryLogger } from '@wix/bi-schema-logger-helpers';
import { Factory } from '@wix/web-bi-logger/dist/src/logger';
import { WidgetMeta, Logger } from '../../../types/WidgetProps';

type DefaultFields = 'msid' | 'visitorId';
export type BiLogger = MandatoryLogger<Logger, DefaultFields>;

export const BiLoggerContext = React.createContext<BiLogger>(null);

export interface Props {
  biLoggerFactory: Factory;
  meta: WidgetMeta;
  sessionId: string;
}

export class BiLoggerProvider extends React.Component<Props> {
  biLogger: BiLogger;

  constructor(props) {
    super(props);
    this.biLogger = this.props.biLoggerFactory
      .updateDefaults({
        appId: this.props.meta.appDefId,
        msid: this.props.meta.siteId,
        visitorId: this.props.meta.visitorId,
        sessionId: this.props.sessionId,
      })
      .logger();
  }

  render() {
    return <BiLoggerContext.Provider value={this.biLogger}>{this.props.children}</BiLoggerContext.Provider>;
  }
}

export const useBiLogger = (): BiLogger => {
  const value = useContext(BiLoggerContext);
  return value;
};
